<template>
    <div class="mit-maps-page mit-page">
        <v-container fluid>
            <v-card class="mit-info-card">
              <v-card-title>Add Person</v-card-title>
              <v-card-subtitle class="caption">Add a new person to the lab</v-card-subtitle>
              <v-divider></v-divider>
              <v-card-text>
                <MitActionsNewPerson/>
              </v-card-text>
            </v-card>
      </v-container>
    </div>
</template>

<script>
  import MitActionsNewPerson from '../../components/actions/MitActionsNewPerson.vue';
  export default {
    name: 'MitActionNewPersonPage',
    components: {
      MitActionsNewPerson
    },
    data: function() {
      return {

      }
  },
    created(){

    },
    methods : {
    }
  }
</script>

<style lang="scss" scoped>
.mit-info-card {
  width:100%;
  height:100%;
}
</style>
